import React from "react";
import { Typography, Form, Input, Button, DatePicker, message } from "antd";
import { useParams, useNavigate } from "react-router-dom";

const { Title } = Typography;

function CreateSprint() {

  const { projectId } = useParams();
  const navigate = useNavigate();

  const saveSprint = async (values) => {

    try {

      const token = localStorage.getItem("access-token");

      const newSprint = {
        projectId: projectId,
        sprintName: values.sprintName,
        duration: values.duration,
        startDate: values.startDate.format("YYYY-MM-DD"),
        sprintGoal: values.sprintGoal,
        status: "Not Started"
      };

      const res = await fetch("https://rhrmapi.up2dateinc.com/api/sprints", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(newSprint)
      });

      const data = await res.json();

      if (res.ok) {
        message.success("Sprint Created Successfully");
        navigate(`/admin/sprints/${projectId}`);
      } else {
        message.error(data.message || "Failed to create sprint");
      }

    } catch (error) {

      message.error("Server Error");

    }

  };

  return (
    <div>

      <Title level={3}>Create Sprint</Title>

      <Form
        layout="vertical"
        style={{ maxWidth: 600 }}
        onFinish={saveSprint}
      >

        <Form.Item
          name="sprintName"
          label="Sprint Name"
          rules={[{ required: true }]}
        >
          <Input placeholder="Sprint-1" />
        </Form.Item>

        <Form.Item
          name="duration"
          label="Duration"
          rules={[{ required: true }]}
        >
          <Input placeholder="1-14 days" />
        </Form.Item>

        <Form.Item
          name="startDate"
          label="From"
          rules={[{ required: true }]}
        >
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          name="sprintGoal"
          label="Sprint Goal"
        >
          <Input.TextArea rows={3} />
        </Form.Item>

        <Button type="primary" htmlType="submit">
          Create Sprint
        </Button>

      </Form>

    </div>
  );
}

export default CreateSprint;